"use client";
import React, { useContext, useEffect, useState } from "react";
import { GetBlogByIdAPI } from "../../helpers/api";
import { UserContext } from "../../contexts/UserContext";
import CloseIcon from "../../components/icons/CloseIcon";
import { useParams } from "react-router-dom";

const PreviewArticle = () => {
  const { user } = useContext(UserContext);
  const { id } = useParams();

  const [detailsData, setDetailsData] = useState([]);
  const [isOpen, setIsOpen] = useState(true);
  const [idFAq, setIdFAq] = useState(0);
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await GetBlogByIdAPI(id, user?.accessToken);
        setDetailsData(response.data);

        console.log("response", response);
      } catch (error) {
        console.error(error);
      }
    };

    fetchBlog();
  }, [user]);

  return (
    <div>
      <div className="relative w-full lg:h-[700px] h-[500px] ">
        <img
          className=" lg:h-[700px] h-[500px] w-full object-cover"
          src={detailsData.image}
          alt=""
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to top, #422EAEc7 10%, rgba(66,46,174,0.8) 45%, transparent 100%)",
          }}
        />
        <div className="lg:pl-[80px] pl-[20px]  lg:pt-[100px] pt-[20%] absolute top-0 lg:top-[5%]">
          <div className="bg-white rounded-[4px] text-[#5754E5] w-fit font-bold font-roboto py-1 px-4 ">
          {detailsData?.type?.charAt(0)?.toUpperCase() + detailsData?.type?.slice(1)}
          </div>
          <h1 className="lg:text-[64px] text-[28px] 2xl:w-[65%] lg:w-[90%] text-start  font-black text-white font-poppins  lg:leading-[80px]">
            {detailsData.blogTitle}{" "}
          </h1>
        </div>
        <div className="flex w-full justify-between items-end absolute -bottom-[100px]  lg:-bottom-6 gap-10 px-[20px] lg:px-[80px]">
          <div
            className=" flex w-full flex-col items-start   
           gap-2"
          >
            <div className=" text-[#B2A4FF] lg:text-[20px]   ">
              {" "}
              {detailsData.DateArticle}
              {detailsData?.type?.charAt(0).toUpperCase() + detailsData?.type?.slice(1)} {detailsData.tags && detailsData.tags?.replace(/\s+/g, '/')}{" "}
            </div>

            <div className="  text-left bg-white w-full min-h-[100px] rounded-[16px] p-5 lg:text-[20px]  text-[#1A191E]">
              {detailsData.shortDescription}
            </div>
          </div>
          {/* <div className=" w-[300px] h-[100px] bg-fuchsia-100">okok</div> */}
          <div className="hidden lg:block w-[300px] mb-10 ">
            <div className="  w-full flex text-[12px] flex-col items-start border-b-[1px] leading-[15px] ">
              <div className="text-[#CCCCCC]  ">Auteur de l’article</div>
              <div className="text-[#FFF]  font-bold pb-1 ">
                {detailsData.auteur}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#F1F1FF] w-full h-full  gap-10 flex justify-between lg:px-[80px]  py-[100px] lg:mt-0 mt-[50px]">
        <div className=" w-fit space-y-5 mx-[20px] lg:mx-0  ">
          <div className=" bg-white  flex flex-col w-full gap-8  border border-1 rounded-[16px]  p-6 ">
            {detailsData.content &&
              detailsData.content.map((content, index) => (
                <div key={index}>
                  {content.image && (
                    <img
                      className="float-left  mr-6 pb-3  rounded object-cover w-[280px]  h-[185px]"
                      src={content.image}
                      width={278}
                      height={182}
                      alt=""
                    />
                  )}
                  <div
                    className="leading-[28px] -mt-[7px] text-left article-content"
                    style={{
                      wordBreak: "normal",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: content.paragraphe.replace(/&nbsp;/g, " "),
                    }}
                  />
                </div>
              ))}
          </div>
          <div className=" bg-white  flex flex-col w-full lg:gap-8 gap-4 text-start border border-1 rounded-[16px]  p-4 ">
            <h2 className="text-[#2D2A66] text-[38px] lg:text-[24px] font-bold ">
              FAQ
            </h2>
            {detailsData.faq &&
              detailsData.faq.map((item, index) => (
                <div
                  key={index}
                  className={`${idFAq === index ? "bg-white border-[#B3A6FF]" : "bg-[#F1F1FF] border-[#D1D1FF]"} cursor-pointer border rounded-[9px] w-full p-4 sm:p-3`}
                  onClick={() => {
                    if (isOpen && index === idFAq) {
                      setIdFAq(-1);
                      setIsOpen(false);
                    } else {
                      setIdFAq(index);
                      setIsOpen(true);
                    }
                  }}
                >
                  <div className="flex justify-between items-center">
                    <span className="text-[#1A191E] font-poppins font-medium 2xl:text-[28px] text-[18px] leading-6">
                      {item.title}
                    </span>
                    <CloseIcon
                      classNames={`${index !== idFAq && "rotate-45"}`}
                      fill="none"
                      stroke="#5754E5"
                    />
                  </div>

                  {index === idFAq && (
                    <div
                      className="lg:mt-4 sm:text-[14px] article-content"
                      dangerouslySetInnerHTML={{
                        __html: item.paragraphe.replace(/&nbsp;/g, " "),
                      }}
                    />
                  )}
                </div>
              ))}
          </div>
        </div>

        <div className="hidden lg:block w-[300px] h-screen bg-white" />
      </div>
    </div>
  );
};

export default PreviewArticle;
